export const PRODUCT_CARD_STATUS = Object.freeze({
  FREE: {
    state: 'free',
    label: 'Try free'
  },
  PURCHASED: {
    state: 'purchased',
    label: 'Purchased'
  },
  REQUESTED: {
    state: 'requested',
    label: 'Requested'
  }
});
